import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PAGES } from 'components/modal-windows/step-details/log-details/log-details.component';
import { LogCorrectionsFormComponent } from 'components/modal-windows/step-details/log-details/modal-content/corrections-form/corrections-form.component';
import { LogService } from 'services/log/log.service';
import { MessageQueryService } from '@certemy/ui-components';

@Component({
  selector: 'cm-log-corrections-content',
  templateUrl: './corrections-content.component.html',
  styleUrls: ['./corrections-content.component.scss'],
})
export class LogCorrectionsContentComponent {
  @Input() entries = [];
  @Input() step;
  @Input() hideButtons: boolean;
  @Output() goToPage = new EventEmitter();
  @Output() close = new EventEmitter();
  @ViewChild(LogCorrectionsFormComponent) correctionsFormComponent: LogCorrectionsFormComponent;
  readonly PAGES = PAGES;
  showErrors = true;

  constructor(private logService: LogService, private messageQueryService: MessageQueryService) {}

  submit() {
    const correctedData = this.correctionsFormComponent.getCorrectionsFormData();

    if (!correctedData) {
      this.showErrors = true;
      return;
    }

    const preparedPayload = this.logService.prepareEntryPayload({
      type: 'multiple',
      data: correctedData,
    });
    this.logService.createEntry(this.step.step_instance_id, preparedPayload).subscribe(() => {
      this.messageQueryService.addMessage(`Your entries have been successfully submitted`);
      this.close.emit();
    });
  }
}
